module.exports = __webpack_public_path__ + "static/media/ic_company.37141a9b.svg";